import { useState } from 'react';
import styles from './searchInput.module.scss';
import IFormInputProps from './interfaces/IFormInputProps';
import TextInputTypes from './enums/TextInputTypes';
import TextInput from './TextInput';
import FeatherIcon from 'feather-icons-react';

interface IProps extends IFormInputProps {
  value?: string;
  type?: TextInputTypes;
  maxLength?: number;
  pattern?: string;
  placeholder?: string;
  forwardedRef?: React.RefObject<HTMLInputElement>;
}

const isIPhoneWithLessThaniOS17 = () => {
  const userAgent = window.navigator.userAgent;
  const isIPhone = /iPhone/i.test(userAgent);
  const iOSVersion = parseFloat(
    ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(userAgent) || [0, ''])[1])
      .replace('undefined', '3_2')
      .replace('_', '.')
      .replace('_', '')
  );
  return isIPhone && iOSVersion < 17;
};
const SearchInput: React.FC<IProps> = (props: IProps) => {
  const { onChangeValue, forwardedRef, ...passThroughProps } = props;
  // This fix was as a result of the duplicate icon behaviour observed in ios devices relating to this ticket DID-6720
  const [shouldHideDoubleIcon] = useState(() => isIPhoneWithLessThaniOS17());

  return (
    <div className={styles.search} data-testid="search-input">
      <span aria-hidden="true" className={styles.icon}>
        <div className={shouldHideDoubleIcon ? styles.hiddenVisibility : ''} data-testid="search-icon">
          <FeatherIcon icon="search" className="w-6 h-7" />
        </div>
      </span>
      <TextInput
        forwardedRef={forwardedRef}
        type={TextInputTypes.SEARCH}
        onChangeValue={onChangeValue}
        {...passThroughProps}
      />
    </div>
  );
};

export default SearchInput;
